import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { withProps } from 'recompose';
import { t } from '../../../../../../modules/infra/i18n';
import Money from '../../../../../common/money';
import RowExpanded from './TotalSalesBreakdownTableRowExpanded';

const MoneyCell = row => <Money>{row.value}</Money>;

const TotalSalesBreakdownTable = ({
  data,
  totals,
  showCountInTotal,
  totalTitle,
  serviceProductTitle,
}) => (
  <div>
    <ReactTable
      showPagination={false}
      minRows={0}
      className="c-total-sales-breakdown-table"
      resizable={false}
      defaultSorted={[
        {
          id: 'services',
          asc: true,
        },
      ]}
      SubComponent={withProps({ showLoanRepayment: totals.loanRepaymentCharge > 0 })(RowExpanded)}
      data={data}
      columns={[
        {
          show: true,
        },
        {
          Header: <span>{serviceProductTitle}</span>,
          id: 'title',
          accessor: 'title',
          width: 300,
          Footer: <span>{showCountInTotal && totals.quantity && `(${totals.quantity})`} {totalTitle}</span>,
        },
        {
          Header: t('reports:breakdown.total_gross_sales'),
          accessor: 'grossTotal',
          id: 'grossTotal',
          Cell: MoneyCell,
          Footer: <Money>{totals.grossTotal}</Money>,
          width: 115,
        },
        {
          Header: t('reports:breakdown.refunds'),
          accessor: 'grossRefunds',
          id: 'grossRefunds',
          Cell: MoneyCell,
          Footer: <Money>{totals.grossRefunds}</Money>,
          width: 115,
        },
        {
          Header: t('reports:breakdown.discounts'),
          accessor: d => d.grossPromo + d.grossDiscounts,
          id: 'grossPromo',
          Footer: <Money>{totals.grossPromo + totals.grossDiscounts}</Money>,
          Cell: MoneyCell,
          width: 115,
        },
        {
          Header: t('reports:breakdown.net_sales'),
          accessor: 'netTotal',
          id: 'netTotal',
          Cell: MoneyCell,
          Footer: <Money>{totals.netTotal}</Money>,
          width: 115,
        },
        {
          Header: t('reports:breakdown.fees'),
          accessor: 'fees',
          id: 'fees',
          Cell: MoneyCell,
          Footer: <Money>{totals.fees}</Money>,
          width: 115,
        },
        ...(totals.loanRepaymentCharge ? [{
          Header: t('reports:breakdown.financing'),
          accessor: 'loanRepaymentCharge',
          id: 'loanRepaymentCharge',
          Cell: MoneyCell,
          Footer: <Money>{totals.loanRepaymentCharge}</Money>,
          width: 115,
        }] : []),
        {
          Header: t('reports:breakdown.taxes'),
          accessor: 'tax',
          id: 'tax',
          Cell: MoneyCell,
          Footer: <Money>{totals.tax}</Money>,
          width: 115,
        },
        {
          Header: t('reports:breakdown.tips'),
          accessor: 'tips',
          id: 'tips',
          Cell: MoneyCell,
          Footer: <Money>{totals.tips}</Money>,
          width: 115,
        },
        {
          Header: t('reports:breakdown.total_collected'),
          accessor: 'totalCollected',
          id: 'totalCollected',
          Cell: MoneyCell,
          Footer: <Money>{totals.totalCollected}</Money>,
          width: 115,
        },
      ]}
    />
  </div>
);

TotalSalesBreakdownTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  totals: PropTypes.shape({
    quantity: PropTypes.number,
    grossTotal: PropTypes.number,
    grossRefunds: PropTypes.number,
    grossPromo: PropTypes.number,
    grossDiscounts: PropTypes.number,
    netTotal: PropTypes.number,
    tax: PropTypes.number,
    tips: PropTypes.number,
    totalCollected: PropTypes.number,
    fees: PropTypes.number,
    loanRepaymentCharge: PropTypes.number,
  }).isRequired,
  showCountInTotal: PropTypes.bool,
  totalTitle: PropTypes.string,
  serviceProductTitle: PropTypes.string,
};
TotalSalesBreakdownTable.defaultProps = {
  showCountInTotal: false,
};

export default TotalSalesBreakdownTable;
